/*
Requires:
Jquery
serialize-element

A small plugin that validates inputs via Laravel default validation.
--------------------

*/
; (function ($, window, document, undefined) {

    "use strict";

    var events = {
        form: {
            onSubmit: function (that, e, settings) {
                e.preventDefault();
                if (window.isFormSubmitting === true) {
                    return;
                }
                window.isFormSubmitting = true;

                var $this = $(this);
                var $form = $this.closest('form');
                var $validationInputs = $form.find(':input[name]');
                var $inputs = $.fn.serializeElement($validationInputs);
                $form.addClass('validating');

                var settingsLocal = jQuery.extend(true, {}, settings, settings.form || {});

                settingsLocal['$validationInputs'] = $validationInputs;
                settingsLocal['$inputs'] = $inputs;

                settingsLocal['$form'] = $form;
                settingsLocal['validateList'] = false;
                settingsLocal['ajax']['url'] = settings.url || $form.attr('action');
                settingsLocal['triggeredEvent'] = e;
                settingsLocal['validationType'] = 'form';

                settingsLocal['status']['valid'] = function (xhr, statusText, validationSettings) {
                    var func = settings['form']['status']['valid'] || settings['status']['valid'];
                    $form.removeClass('validating');
                    $form.trigger('formValidated', { valid: 'valid', xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };
                settingsLocal['status']['invalid'] = function (xhr, statusText, validationSettings) {
                    validationSettings.defaultInvalidFunction = status.form.invalid;
                    var func = settings['form']['status']['invalid'] || settings['status']['invalid'];
                    $form.removeClass('validating');
                    $form.trigger('formValidated', { valid: 'invalid', xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };
                settingsLocal['status']['error'] = function (xhr, statusText, validationSettings) {
                    var func = settings['form']['status']['error'] || settings['status']['error'];
                    $form.removeClass('validating');
                    $form.trigger('formError', { xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };

                $.validateInputs(settingsLocal);
                window.isFormSubmitting = false;
            }
        },
        field: {
            onChange: function (that, e, settings) {

                var $this = $(this);
                var $form = $this.closest('form');
                var fieldName = $this.attr('name');

                settings.field = settings.field || {};

                var settingsLocal = jQuery.extend(true, {}, settings, settings.field);
                settingsLocal['$inputs'] = $this;
                settingsLocal['$form'] = $form;
                settingsLocal['validateList'] = true;
                settingsLocal['validationType'] = 'field';
                settingsLocal['ajax']['url'] = settings.validateUrl || $form.data('validation') || settings.url;

                settings['field']['status'] = settings['field']['status'] || {};

                settingsLocal['status']['valid'] = that.getFunctionFromId(settings['field']['status']['valid'] || settings['status']['valid'], fieldName);
                settingsLocal['status']['invalid'] = that.getFunctionFromId(settings['field']['status']['invalid'] || settings['status']['invalid'], fieldName);

                settingsLocal['status']['error'] = function (xhr, statusText, validationSettings) {
                    var func = that.getFunctionFromId(settings['field']['status']['error'] || settings['status']['error'], fieldName);
                    if (settingsLocal['throwErrors']) {
                        $this.trigger('error', { xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    }
                    func.apply(null, arguments);
                };

                settingsLocal['triggeredEvent'] = e;
                $.validateInputs(settingsLocal);

            }
        },
        page: {
            onClick: function (that, e, settings) {
                e.preventDefault();
                var $this = $(this);
                var $page = $this.closest('.' + settings.page.class);
                var $form = $this.closest('form');
                var $pageInputs = $page.find(':input[name]');
                var pageIndex = $page.index('.' + settings.page.class);
                $page.addClass('validating');

                settings.page = settings.page || {};

                var settingsLocal = jQuery.extend(true, {}, settings, settings.page);
                settingsLocal['$inputs'] = $.fn.serializeElement($pageInputs);
                settingsLocal['$form'] = $form;
                settingsLocal['$page'] = $page;
                settingsLocal['validationType'] = 'page';
                settingsLocal['pageIndex'] = pageIndex;
                settingsLocal['validateList'] = true;
                settingsLocal['ajax']['url'] = settings.validateUrl || $form.data('validation') || settings.url;

                settings['page']['status'] = settings['page']['status'] || {};
                settingsLocal['status']['valid'] = function (xhr, statusText, validationSettings) {
                    var func = that.getFunctionFromId(settings['page']['status']['valid'] || settings['status']['valid'], pageIndex);
                    $page.removeClass('validating');
                    $page.trigger('pageValidated', { valid: 'valid', xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };
                settingsLocal['status']['invalid'] = function (xhr, statusText, validationSettings) {
                    validationSettings.defaultInvalidFunction = status.page.invalid;
                    var func = that.getFunctionFromId(settings['page']['status']['invalid'] || settings['status']['invalid'], pageIndex);
                    $page.removeClass('validating');
                    $page.trigger('pageValidated', { valid: 'invalid', xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };
                settingsLocal['status']['error'] = function (xhr, statusText, validationSettings) {
                    var func = that.getFunctionFromId(settings['page']['status']['error'] || settings['status']['error'], pageIndex);
                    $page.removeClass('validating');
                    $page.trigger('pageError', { xhr: xhr, statusText: statusText, validationSettings: validationSettings });
                    func.apply(null, arguments);
                };
                settingsLocal['triggeredEvent'] = e;
                $.validateInputs(settingsLocal);
            }
        },
        ajax: {
            onComplete: function (xhr, statusText) {
                this.validationSettings['$inputs'].removeClass('valid invalid').closest('.form-group').removeClass('valid invalid').removeClass('valid invalid');
                switch (xhr.status) {
                    case 422:
                        this.validationSettings.displayMessages(this.validationSettings['$validationInputs'] || this.validationSettings['$inputs'], xhr.responseJSON || {}, this.validationSettings);
                        this.validationSettings.status.invalid(xhr, statusText, this.validationSettings);
                        break;
                    case 200:
                        this.validationSettings.displayMessages(this.validationSettings['$validationInputs'] || this.validationSettings['$inputs'], xhr.responseJSON || {}, this.validationSettings);
                        this.validationSettings.status.valid(xhr, statusText, this.validationSettings);
                        break;
                    default:
                        this.validationSettings.status.error(xhr, statusText, this.validationSettings, this.validationSettings);
                        break;
                }
            },
            onBeforeSend: function (jqXHR, settings) {
                return settings.data = jQuery.param(settings.data, false);
            }
        }

    };

    var invalidFunction = function (xhr, statusText, settings) {
        $.each(settings['$inputs'], function (key, input) {
            var $input = $(input);
            var xhrResponse = xhr.responseJSON || {};
            if (typeof xhrResponse.errors !== typeof void 0 && typeof xhrResponse.errors[$input.attr('name')] !== typeof void 0) {

                if (settings.pager !== false) {
                    var $formGroup = $input.closest('.form-group');
                    settings.pager.goToElement($formGroup);
                } else {
                    var $formGroup = $input.closest('.form-group');

                    var elOffset = $formGroup.offset().top;
                    var elHeight = $formGroup.height();
                    var windowHeight = $(window).height();
                    var offset;

                    if (elHeight < windowHeight) {
                        offset = elOffset - ((windowHeight / 2) - (elHeight / 2));
                    } else {
                        offset = elOffset;
                    }

                    $('html, body').animate({ scrollTop: offset }, 200);
                }
                return false;
            }
        });
    };

    var status = {
        page: {
            invalid: invalidFunction
        },
        form: {
            invalid: invalidFunction
        }
    };

    var pluginName = "formValidation",
        defaults = {
            // Only for override
            displayMessages: null,
            events: {
                form: {
                    onSubmit: events.form.onSubmit
                },
                field: {
                    onChange: events.field.onChange
                },
                page: {
                    onClick: events.page.onClick
                },
            },
            ajax: {
                type: "POST",
                url: '',
                data: {},
                complete: events.ajax.onComplete,
                beforeSend: events.ajax.onBeforeSend,
                processData: false
            },
            page: {
                class: 'validate-page',
                status: {
                    invalid: status.page.invalid
                }
            },
            form: {
                status: {
                    invalid: status.form.invalid
                }
            },
            status: {
                valid: function (xhr, statusText, settings) { },
                invalid: function (xhr, statusText, settings) { },
                error: function (xhr, statusText, settings) { },
            },
            validationType: '',
            pager: false,
            validateList: true,
            delegation: false,
            $inputs: $(),
            $form: $(),
            url: '',
            validateUrl: '',
            throwErrors: true,
        },
        publicFunctions = {
            createUrl: function (base, params) {
                base += (base.indexOf('?') > -1) ? '&' : '?';
                return base + $.param(params);
            },
            createSlug: function (base, params) {
                base += (base.substr(base.length - 1) > -1) ? '' : '/';
                return base + params.join('/');
            },
            ajax: {
                beforeSend: events.ajax.onBeforeSend
            }
        };

    var functions = {
        getRequiredInputs: function (options) {
            var inputNames = [];
            var requiredInputs = ['journey'];
            options['$inputs'].each(function () {
                var $this = $(this);
                var inputName = $this.attr('name');
                inputNames.push(inputName);

                var dataRequires = $this.data('validation-requires');

                if (typeof dataRequires === typeof void 0 || !dataRequires.length) {
                    return;
                }

                if ($.isArray(dataRequires)) {
                    requiredInputs = requiredInputs.concat(dataRequires);
                } else {
                    requiredInputs.push(dataRequires);
                }
            });

            var requiredInputs = requiredInputs.filter(function (i) { return inputNames.indexOf(i) < 0; });
            return $('[name="' + requiredInputs.join('"], [name="') + '"]', options['$form']);
        },
        convertInputsToObject: function ($inputs) {
            var inputList = {};

            $.each($.fn.serializeElement($inputs), function (key, input) {
                var $input = $(input);
                var inputName = $input.attr('name');
                var inputNameArr = inputName.match(/[^\[\]]{1,}|\[\]/g);
                var inputNameLastArr = inputNameArr.pop();
                var inputValue = $input.val();

                if ($input[0].hasAttribute("data-onsubmit-strip")) {
                    var onSubmitStrip = $input.data('onsubmit-strip');

                    if (onSubmitStrip.substr(0, 6) === 'regex:') {
                        var regexStr = onSubmitStrip.substr(6);
                        var regex = functions.stringToRegex(regexStr);
                        inputValue = inputValue.replace(regex, '');
                    } else {
                        var regex = new RegExp(onSubmitStrip.split('').join('|'), 'g');
                        inputValue = inputValue.replace(regex, '');
                    }
                }

                var inputListRef = inputList;

                $.each(inputNameArr, function (key, name) {
                    if (typeof inputListRef[name] === typeof void 0) {
                        if (name === '[]' || key === inputNameArr.length - 1 && inputNameLastArr === '[]') {
                            inputListRef[name] = [];
                        } else {
                            inputListRef[name] = {};
                        }
                    }
                    inputListRef = inputListRef[name];

                });

                if (inputNameLastArr === '[]') {
                    if (typeof inputListRef === typeof void 0) {
                        inputListRef = [];
                    }
                    inputListRef.push(inputValue);
                } else {
                    inputListRef[inputNameLastArr] = inputValue;
                }

            });
            return inputList;
        },
        stringToRegex: function (str) {
            var parts = str.split('/');
            var regex = str;
            var options = "";
            if (parts.length > 1) {
                regex = parts[1];
                options = parts[2];
            }
            try {
                return new RegExp(regex, options);
            }
            catch (e) {
                return false;
            }
        },
    };

    // The actual plugin constructor
    function Plugin(element, selector, options) {
        this.element = element;
        defaults.displayMessages = $.formValidationMessages;

        this.settings = $.extend(true, {}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;
        this.init(selector);
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function (selector) {
            this.bindPersistedCacheFix();
            var that = this;
            if (this.settings.delegation) {
                $(this.element).on('submit', selector, function (e) {
                    that.settings.events.form.onSubmit.call(this, that, e, that.settings);
                });
                $(this.element).on('change validate', selector + ' .validate-otf', function (e) {
                    that.settings.events.field.onChange.call(this, that, e, that.settings);
                });
                $(this.element).on('click', selector + ' .validate-page-btn', function (e) {
                    that.settings.events.page.onClick.call(this, that, e, that.settings);
                });
                return this;
            }

            return $(selector).each(function () {
                var $this = $(this);
                if (!$this.is('form')) {
                    throw 'formValidation must be initialised on a form';
                }

                that.settings.url = that.settings.url || $this.attr('action');
                that.settings.validateUrl = that.settings.validateUrl || $this.data('validation') || that.settings.url;

                $this.on('submit', function (e) {
                    that.settings.events.form.onSubmit.call(this, that, e, that.settings);
                });
                $this.on('change validate', '.validate-otf', function (e) {
                    that.settings.events.field.onChange.call(this, that, e, that.settings);
                });
                $this.on('click', '.validate-page-btn', function (e) {
                    that.settings.events.page.onClick.call(this, that, e, that.settings);
                });
            });

        },
        bindPersistedCacheFix: function () {
            $(window).bind("pageshow", function (event) {
                if (!event.originalEvent.persisted) {
                    return;
                }

                if (this.settings.page && this.settings.page.class) {
                    $('.' + this.settings.page.class + '.validating').removeClass('validating');
                }
            });
        },
        getFunctionFromId: function (functionList, id) {

            if ($.isArray(functionList) || $.isPlainObject(functionList)) {
                return functionList[id] || function () { };
            }

            return functionList;

        },
        getRequiredInputs: functions.getRequiredInputs,
        convertInputsToObject: functions.convertInputsToObject
    });

    $.fn[pluginName] = function (selector, options) {
        return this.each(function () {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" +
                    pluginName, new Plugin(this, selector, options));
            }
        });
    };

    $[pluginName] = function (selector, options) {
        return new Plugin(document.body, selector, options);
    };


    $.formValidationMessages = function ($inputs, xhrResponse, settings) {
        xhrResponse = xhrResponse || {};
        var errors = [];

        if (typeof xhrResponse.message !== typeof xhrResponse.message && xhrResponse.message !== "The given data was invalid.") return;

        var errorMessages = function ($field, messages) {
            var $wrapper = $field.closest('.form-group');
            var $error = $wrapper.find('.form-input-error');
            $error.html(messages[0] || '');
            $wrapper.addClass('invalid');
        }

        var successMessages = function ($field) {
            $field.closest('.form-group').addClass('valid');
        }

        $.each($inputs, function (key, input) {
            var $input = $(input);
            var valid = false;

            if (typeof xhrResponse.errors !== typeof void 0 && typeof xhrResponse.errors[$input.attr('name')] !== typeof void 0) {

                errors = xhrResponse.errors[$input.attr('name')];
                errorMessages($input, errors);

            } else {

                successMessages($input);
                valid = true;

            }
            if (settings.validationType === 'field') {
                $input.trigger('inputValidated', { valid: valid, errors: errors });
            }
            $input.trigger('summaryInputValidated', { valid: valid, errors: errors });
        });

        return this;

    };
    defaults.displayMessages = $.formValidationMessages;

    $.validateInputs = function (options) {
        var settings = $.extend(true, {}, defaults, options);

        var $formInputs = settings['$inputs'].first().closest('form').find(':input[name]');
        var $inputs = $.fn.serializeElement($formInputs);

        var $requiredInputs = functions.getRequiredInputs(settings);
        var $inputData = settings['$inputs'].add($requiredInputs).filter('[name]');

        var $data = $();
        $inputData.map(function () {
            $data = $data.add($inputs.filter('[name="' + $(this).attr('name') + '"]'));
        });

        var data = functions.convertInputsToObject($data);

        if (settings['validateList']) {
            data['validate'] = [];
            settings['$inputs'].filter('[name]').each(function () {
                var name = $(this).attr('name');
                if (data['validate'].indexOf(name) !== -1) return true;
                data['validate'].push(name);
            });
        }

        settings['formData'] = data;
        settings['functions'] = publicFunctions;

        try {
            $.ajax($.extend(true, {}, { data: data, validationSettings: settings }, settings.ajax));
        } catch (e) { }
    };

    $.formValidateOnload = function (selector, options) {

        var settings = $.extend(true, {}, defaults, options);

        var $form = $(selector);
        var $validateInputs = $.fn.serializeElement($form.find(':input[name]')).filter(function () {
            return $(this).val() !== '';
        });

        if ($validateInputs.length > 0) {
            $.validateInputs({
                '$inputs': $validateInputs,
                'ajax': {
                    'url': settings.validateUrl || $form.data('validation') || settings.url
                }
            });
        }
    };

})(jQuery, window, document);